// eslint-disable-next-line no-shadow
export enum LayoutOrientation {
	HORIZONTAL = 'horizontal',
	VERTICAL = 'vertical',
}
